
// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const faqApi = baseApi.injectEndpoints({

  credentials: "include",
  endpoints: (builder) => ({
    addFaqs: builder.mutation({
      query: (data) => {
        return {
          url: "admin/feedback-question",
          method: "POST",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    updateFaqs: builder.mutation({
      query: ({data, slug}) => {
        return {
          url: `admin/feedback-question/${slug}`,
          method: "PATCH",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    deleteFaqs: builder.mutation({
      query: (slug) => {
        return {
          url: `admin/feedback-question/${slug}`,
          method: "DELETE",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    getAllFaqs: builder.query({
      query: ({ limit, page }) => {
        return {
          url: `admin/feedback-question?limit=${limit}&page=${page}`, // todo:
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          // },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    getUserFeedback: builder.query({
      query: ({ limit, page }) => {
        return {
          url: `admin/user-feedback?limit=${limit}&page=${page}`, // todo:
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          // },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    getFeedbackDetails: builder.query({
      query: ({ id }) => {
        return {
          url: `admin/user-feedback-details/${id}`, // todo:
          method: "GET",
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
  }),
});

export const {
  useAddFaqsMutation,
  useUpdateFaqsMutation,
  useDeleteFaqsMutation,
  useGetAllFaqsQuery,
  useGetUserFeedbackQuery,
  useGetFeedbackDetailsQuery,
} = faqApi;